import { render } from "./Roles.vue?vue&type=template&id=70cde59e&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=70cde59e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70cde59e"

export default script